class Group {

  public id: number;
  public uuid: number;
  public label: string;
  public usersCount: number = 0;

  public static fromPayload(pl: Partial<Group>) {
    !pl && (pl = {});
    const o = new Group()
    Object.assign(o, pl);
    return o;
  }

  clone(){
    const gr = new Group();
    gr.id = this.id;
    gr.uuid = this.uuid;
    gr.label = this.label;
    gr.usersCount = this.usersCount;
    return gr;
  }

}

export { Group }
